import { ERequestType } from "../api";
import { ERoutes } from "../ERoutes";
import { EDrupalRoutes } from "../drupal/EDrupalRoutes";
export function getRouteStr(requestTypeCode, subRequestId, mode) {
  switch (requestTypeCode) {
    case ERequestType.WorkAttestRequest:
      return `${ERoutes.workAttestationRequest}/${subRequestId}/detail/${mode}`;
    case ERequestType.WorkbookRequest:
      return `${ERoutes.workbookRequest}/${subRequestId}/detail/${mode}`;
    case ERequestType.DogOwnershipChangeRequest:
      return `${ERoutes.rsh}/${subRequestId}/detail/${mode}`;
    case ERequestType.KennelImportRequest:
      return `${ERoutes.affixRequest}/${subRequestId}/detail/${mode}/kennelImport`;
    case ERequestType.KennelOwnershipChangeRequest:
      return `${ERoutes.affixRequest}/${subRequestId}/detail/${mode}/kennelOwnership`;
    case ERequestType.NewKennelRequest:
      return `${ERoutes.affixRequest}/${subRequestId}/detail/${mode}/newKennel`;
    case ERequestType.KennelExportRequest:
      return `${ERoutes.affixRequest}/${subRequestId}/detail/${mode}/kennelExport`;
    case ERequestType.KennelNameChangeRequest:
      return `${ERoutes.affixRequest}/${subRequestId}/detail/${mode}/kennelNameChange`;
    case ERequestType.DogTempOwnershipChangeRequest:
      return `${ERoutes.tempRsh}/${subRequestId}/detail/${mode}`;
    case ERequestType.BroodRequest:
      return `${ERoutes.broodRequest}/${subRequestId}/detail/${mode}`;
    case ERequestType.PedigreeDuplicataRequest:
      return `${ERoutes.pedigreeDuplicata}/${subRequestId}/detail/${mode}`;
    case ERequestType.CompetitionRequest:
      return `${ERoutes.competitionRequest}/${subRequestId}/detail/${mode}`;
    case ERequestType.PedigreeRequest:
      return `${ERoutes.rish}/${subRequestId}/detail/${mode}`;
    case ERequestType.TitleRequest:
      return `${ERoutes.titleRequests}/${subRequestId}/detail/${mode}`;
    case ERequestType.ImportRequest:
      return `${ERoutes.importRequest}/${subRequestId}/detail/${mode}`;
    case ERequestType.DysplasiaRequest:
      return `${ERoutes.dysplasiaRequest}/${subRequestId}/detail/${mode}`;
    case ERequestType.HealthTestRequest:
      return `${ERoutes.healthTestRequest}/${subRequestId}/detail/${mode}`;
    case ERequestType.MiscellaneousRequest:
      return `${ERoutes.miscellaneousRequest}/${subRequestId}/detail/${mode}`;
    case ERequestType.MembershipRequest:
      return `${ERoutes.membershipRequest}/${subRequestId}/detail/${mode}`;
    case ERequestType.ExpatriationRequest:
      return `${ERoutes.expatriationRequest}/${subRequestId}/detail/${mode}`;
  }
}
export function getDrupalRouteStr(requestType: ERequestType) {
  switch (requestType) {
    case ERequestType.WorkAttestRequest:
      return EDrupalRoutes.workAttestRequest;
    case ERequestType.WorkbookRequest:
      return EDrupalRoutes.workbookRequest;
    case ERequestType.DogOwnershipChangeRequest:
      return EDrupalRoutes.dogOwnershipChangeRequest;
    case ERequestType.KennelImportRequest:
      return EDrupalRoutes.kennelImportRequest;
    case ERequestType.KennelOwnershipChangeRequest:
      return EDrupalRoutes.kennelOwnershipChangeRequest;
    case ERequestType.NewKennelRequest:
      return EDrupalRoutes.newKennelRequest;
    case ERequestType.KennelExportRequest:
      return EDrupalRoutes.kennelExportRequest;
    case ERequestType.KennelNameChangeRequest:
      return EDrupalRoutes.kennelNameChangeRequest;
    case ERequestType.DogTempOwnershipChangeRequest:
      return EDrupalRoutes.tempRshRequest;
    case ERequestType.BroodRequest:
      return EDrupalRoutes.broodRequest;
    case ERequestType.PedigreeDuplicataRequest:
      return EDrupalRoutes.pedigreeDuplicataRequest;
    case ERequestType.CompetitionRequest:
      return EDrupalRoutes.portalNewCompetitionRequest;
    case ERequestType.PedigreeRequest:
      return EDrupalRoutes.rishRequest;
    case ERequestType.TitleRequest:
      return EDrupalRoutes.titleRequest;
    case ERequestType.ImportRequest:
      return EDrupalRoutes.ImportRequst;
    case ERequestType.DysplasiaRequest:
      return EDrupalRoutes.dysplasiaRequest;
    case ERequestType.HealthTestRequest:
      return EDrupalRoutes.healthTestRequest;
    case ERequestType.MiscellaneousRequest:
      return EDrupalRoutes.miscellaneousRequest;
    case ERequestType.MembershipRequest:
      return EDrupalRoutes.membershipRequest;
    // case ERequestType.ExpatriationRequest:
    //   return `${EDrupalRoutes.expatriationRequest}/${subRequestId}/detail/${mode}`;
  }
}
